// Thin fetch wrappers around the backend API. Adds Authorization header
// from localStorage when a token is present, and surfaces 401s by clearing
// the token and broadcasting a `nyce-auth-changed` event for the store.

const TOKEN_KEY = "nyce-auth-token";
const J = { "Content-Type": "application/json" };

export function getAuthToken() {
  try { return localStorage.getItem(TOKEN_KEY); } catch { return null; }
}
export function setAuthToken(t) {
  try {
    if (t) localStorage.setItem(TOKEN_KEY, t);
    else   localStorage.removeItem(TOKEN_KEY);
  } catch { /* ignore */ }
}

async function req(method, path, body) {
  const headers = body ? { ...J } : {};
  const tok = getAuthToken();
  if (tok) headers.Authorization = `Bearer ${tok}`;

  const res = await fetch(path, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });

  if (res.status === 401) {
    setAuthToken(null);
    window.dispatchEvent(new Event("nyce-auth-changed"));
    throw new Error(`${method} ${path} → 401 unauthorized`);
  }
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`${method} ${path} → ${res.status}: ${text}`);
  }
  return res.json();
}

export const api = {
  health:        ()           => req("GET", "/api/health"),
  meta:          ()           => req("GET", "/api/meta"),

  authStatus:    ()           => req("GET", "/api/auth/status"),
  authLogin:     (password)   => req("POST", "/api/auth/login", { password }),

  listTasks:         ()       => req("GET", "/api/tasks"),
  listArchivedTasks: ()       => req("GET", "/api/tasks?archived=true"),
  createTask:    (body)       => req("POST", "/api/tasks", body),
  getTask:       (id)         => req("GET", `/api/tasks/${id}`),
  updateTask:    (id, patch)  => req("PUT", `/api/tasks/${id}`, patch),
  resetTask:     (id)         => req("POST", `/api/tasks/${id}/reset`),
  resetAllTasks: ()           => req("POST", `/api/tasks/reset-all`),
  reorderTasks:  (orderedIds) => req("POST", `/api/tasks/reorder`, { orderedIds }),
  duplicateTask: (id)         => req("POST", `/api/tasks/${id}/duplicate`),

  getSettings:    ()          => req("GET", "/api/settings"),
  updateSettings: (patch)     => req("PUT", "/api/settings", patch),
  resetSettings:  ()          => req("POST", "/api/settings/reset"),

  listMilestones:   ()           => req("GET", "/api/milestones"),
  createMilestone:  (body)       => req("POST", "/api/milestones", body),
  updateMilestone:  (id, patch)  => req("PUT", `/api/milestones/${id}`, patch),
  deleteMilestone:  (id)         => req("DELETE", `/api/milestones/${id}`),
};
